import axios from './http';
import { CancelTokenSource } from 'axios';
import { ZipDataDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/zip-data`;

export const searchZipDataForInput = (query: string, countryId: number, source: CancelTokenSource, limit?: number): Promise<Array<ZipDataDto>> => {

  const queryParams = {
    query: query,
    countryId: countryId,
    limit: limit
  };

  return axios
      .get(apiUri, { cancelToken: source.token, params: queryParams })
      .then(response => response.data);
};
